const { errors } = require('@transfeeradev/api-enums');
const ErrorMessageCompiler = require('@transfeeradev/api-services/ErrorMessageCompiler');
const merge = require('deepmerge');

module.exports = class SchemaErrorMessagesFactory {
  constructor(schema) {
    this._schema = merge({}, schema);
  }

  build() {
    const errorMessages = merge({}, errors.ptBr.dba);
    let key;

    for (key in errorMessages) {
      const message = errorMessages[key];
      errorMessages[key] = new ErrorMessageCompiler(message, this._schema).compile();
    }

    return errorMessages;
  }
};
